// Test IDs for auth + governance + LLM config + prompts screens
export const AUTH = {
    loginEmail: "login-email",
    loginPassword: "login-password",
    loginSubmit: "login-submit",
    loginError: "login-error",
    logoutButton: "logout-button",
    demoAdminChip: "demo-admin-chip",
    demoCreatorChip: "demo-creator-chip",
};

export const NAV = {
    forgeLink: "nav-forge",
    governanceLink: "nav-governance",
    llmConfigLink: "nav-llm-config",
    promptsLink: "nav-prompts",
    userChip: "nav-user-chip",
};

export const GOVERNANCE = {
    kpi24h: "kpi-24h",
    kpi7d: "kpi-7d",
    kpi30d: "kpi-30d",
    kpiMonth: "kpi-month",
    budgetBarUser: "budget-bar-user",
    budgetBarOrg: "budget-bar-org",
    alertBanner: "alert-banner",
    userTable: "user-table",
    userRow: (id) => `user-row-${id}`,
    saveBudgetBtn: (id) => `save-budget-${id}`,
    orgBudgetInput: "org-budget-input",
    orgBudgetSave: "org-budget-save",
    timeseriesChart: "timeseries-chart",
};

export const LLMCFG = {
    enableToggle: (key) => `llm-enable-${key}`,
    agentSelect: (agentId) => `agent-model-${agentId}`,
    saveButton: "llm-config-save",
    cacheToggle: "cache-toggle",
    cacheTtlInput: "cache-ttl-input",
};

export const PROMPTS = {
    agentTab: (id) => `prompt-tab-${id}`,
    textarea: "prompt-textarea",
    noteInput: "prompt-note",
    saveBtn: "prompt-save",
    revertBtn: "prompt-revert",
    versionRow: (id) => `prompt-version-${id}`,
};
